import React, { useState, useEffect } from "react";
import { useAppSelector } from "../../store/hooks";
import { selectIsAdmin } from "../../store/authSelectors";
import { useAuthAPI } from "../../hooks/api/use-authAPI";
import { selectFullName } from "../../store/slices/authSlice";
import { Button } from "primereact/button";
import { Sidebar } from "primereact/sidebar";
import { StyledIconSmall } from "../StyledIcon/StyledIcon";
import {
  Logo,
  IconSearchFilled,
  IconLogout,
  IconGear,
  IconMobileMenu,
  IconUserFilled,
  IconCompanyFilled,
  IconCaseFilled,
  IconDocFilled,
  IconGearFilled,
  IconLogoutFilled,
} from "../../assets/icons/Icon";
import {
  StyledMenu,
  LogoFlex,
  LogoLink,
  Nav,
  NavMobile,
  NavLink,
  NavLinkBox,
  UserBlock,
  UserManagement,
  User,
  UserName,
  UserRole,
  MobileMenuButton,
} from "./Menu.styles";

interface MenuProps {}

const Menu: React.FC<MenuProps> = ({}) => {
  const isAdmin = useAppSelector(selectIsAdmin);
  const { handleLogout } = useAuthAPI();

  const [mobileVisible, setMobileVisible] = useState<boolean>(false);
  const user = useAppSelector((state) => state.auth.user);
  const fullName = useAppSelector(selectFullName);
  const [userName, setUserName] = useState("Фамилия Имя Отчество");
  const [userRole, setUserRole] = useState("Не указано");

  useEffect(() => {
    if (fullName) {
      setUserName(fullName);
    }
    if (user) {
      setUserRole(
        user.roles?.[0] === "SystemAdmin" ? "Администратор" : "Не указано"
      );
    } else {
      setUserName("Фамилия Имя Отчество");
      setUserRole("Не указано");
    }
  }, [user]);

  return (
    <StyledMenu>
      <LogoFlex>
        <Logo size={32} />
        <LogoLink to="/">idt.license</LogoLink>
      </LogoFlex>

      <Nav>
        {isAdmin && <NavLink to="/companies">Компании</NavLink>}
        {isAdmin && <NavLink to="/users">Пользователи</NavLink>}
        {isAdmin && <NavLink to="/projects">Проекты</NavLink>}
        {isAdmin && <NavLink to="/licenses">Лицензии</NavLink>}
      </Nav>

      <UserBlock>
        <UserManagement>
          {/* <Button severity="secondary">
            <IconSearchFilled size={20} />
          </Button> */}
          <Button severity="secondary" onClick={handleLogout}>
            <IconLogout size={20} />
          </Button>
          {/* <Button severity="secondary">
            <IconGear size={20} />
          </Button> */}
        </UserManagement>
        <User>
          <UserName>{userName}</UserName>
          <UserRole>{userRole}</UserRole>
        </User>
      </UserBlock>

      {isAdmin && (
        <MobileMenuButton>
          <Button text onClick={() => setMobileVisible(true)}>
            <IconMobileMenu size={26} />
          </Button>
        </MobileMenuButton>
      )}

      <Sidebar
        visible={mobileVisible && isAdmin}
        onHide={() => setMobileVisible(false)}
        position="right"
      >
        <NavMobile>
          <NavLink to="/companies" onClick={() => setMobileVisible(false)}>
            <NavLinkBox>
              <StyledIconSmall icon={<IconCompanyFilled size={16} />} />
              Компании
            </NavLinkBox>
          </NavLink>
          <NavLink to="/users" onClick={() => setMobileVisible(false)}>
            <NavLinkBox>
              <StyledIconSmall icon={<IconUserFilled size={16} />} />
              Пользователи
            </NavLinkBox>
          </NavLink>
          <NavLink to="/projects" end onClick={() => setMobileVisible(false)}>
            <NavLinkBox>
              <StyledIconSmall icon={<IconCaseFilled size={16} />} />
              Проекты
            </NavLinkBox>
          </NavLink>
          <NavLink to="/licenses" end onClick={() => setMobileVisible(false)}>
            <NavLinkBox>
              <StyledIconSmall icon={<IconDocFilled size={16} />} />
              Лицензии
            </NavLinkBox>
          </NavLink>
          {/* <NavLink to="/" end onClick={() => setMobileVisible(false)}>
            <NavLinkBox>
              <StyledIconSmall icon={<IconGearFilled size={16} />} />
              Настройки
            </NavLinkBox>
          </NavLink> */}
          <NavLink to="/login" onClick={handleLogout}>
            <NavLinkBox>
              <StyledIconSmall icon={<IconLogoutFilled size={16} />} />
              Выход
            </NavLinkBox>
          </NavLink>
        </NavMobile>
      </Sidebar>
    </StyledMenu>
  );
};

export default Menu;
